import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { OffersByProductIdResponseDto } from '@hub-la/sdk-bff-product'
import { inject } from 'inversify'
import { ListOffersInput } from '../../domain/dtos/offers/list-offers'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class GetOffersList {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input?: ListOffersInput, signal?: AbortSignal): Promise<OffersByProductIdResponseDto> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input?.productId}/offers`,
      params: {
        page: input?.page ?? 1,
        pageSize: input?.pageSize ?? 100,
      },
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }
}
